import { CasTabButtonsView } from 'src/compass/shared/components';

import DeadReportTab from './DeadReportTab';
import NoticeReceivedTab from './NoticeReceivedTab';
import DocusignReceivedTab from './DocusignReceivedTab';
import RejectedTab from './RejectedTab';

export default function EntryTab() {
  return (
    <CasTabButtonsView
      buttonList={[
        { label: 'Dead Report', children: <DeadReportTab /> },
        { label: 'Notice Received', children: <NoticeReceivedTab />, icon: 'tabler:message-down'},
        { label: 'Docusign Received', children: <DocusignReceivedTab />, icon: 'uil:file-download-alt' },
        { label: 'Rejected', children: <RejectedTab />, color: 'error', icon: 'mdi:close-octagon' },
      ]}
    />
  );
}
